"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inMemoryStore = function () {
    var store = {};
    return {
        name: 'inMemoryStore',
        get: function (flagName) { return store[flagName] || null; },
        set: function (flagName, value) {
            store[flagName] = value;
        },
        remove: function (flagName) { return delete store[flagName]; },
        all: function () { return store; }
    };
};
//# sourceMappingURL=in-memory-store.js.map